// Centralized Content Type config used across Task Table, Task Detail,
// Manager Approval Queue, Developer Queue, UI/UX Queue, Bulk Update,
// Filters and Activity Logs. Keep this as the single source of truth.

export const CONTENT_TYPES = [
  'Website Blog',
  'LinkedIn Article',
  'Landing Page',
  'Web Page Content',
  'Social Media Post',
  'Other'
];

// Tailwind classes for the content type badges.
// Website Blog -> Blue, LinkedIn Article -> Dark Blue, Landing Page -> Green,
// Web Page Content -> Teal, Social Media Post -> Purple, Other -> Grey
export const CONTENT_TYPE_BADGE_CLASSES = {
  'Website Blog': 'bg-blue-100 text-blue-700',
  'LinkedIn Article': 'bg-blue-200 text-blue-900',
  'Landing Page': 'bg-green-100 text-green-700',
  'Web Page Content': 'bg-teal-100 text-teal-700',
  'Social Media Post': 'bg-purple-100 text-purple-700',
  'Other': 'bg-slate-100 text-slate-700'
};

export const getContentTypeBadgeClasses = (contentType) => {
  return CONTENT_TYPE_BADGE_CLASSES[contentType] || CONTENT_TYPE_BADGE_CLASSES['Other'];
};

export const formatContentType = (contentType) => {
  return contentType && contentType.trim() ? contentType : 'N/A';
};
